<template>
  <div class="pb-5 px-md-3">
    <ValidationObserver v-slot="{ invalid }" ref="formValidationObserver" class="pagex">
      <b-form>
        <!--Title/Actions-->
        <div class="page-header">
          <div class="container d-flex justify-content-between p-0">
            <h3>Notification Subscription <span class="ml-2" v-if="subscription.name">({{subscription.name}})</span></h3>
            <div class="d-flex align-items-center">
              <router-link title="Close" :to="{ name: 'Notifications'}">
                <b-button variant="light">Close</b-button>
              </router-link>
              <b-button variant="primary" class="ml-1" @click="doSaveSubscription" :disabled="(invalid == true || hasInactiveRolesAssigned)">Save</b-button>
            </div>
          </div>
        </div>
        <div v-if="loading" class="container form-container p-5 p-md-4 d-flex justify-content-center">
          <span><b-spinner small label="Small Spinner"></b-spinner> Loading subscription...</span>
        </div>
        <div v-else class="container form-container notification-scroller">
          <div class="row p-relative">
            <div class="col-md-9 p-lg-5 p-md-4 p-3 order-md-1 order-2 flex-grow-1 notification-scroller overflow-scroll">
              <div v-show="hasInactiveRolesAssigned" class="alert alert-warning">This subscription is assigned to one or more inactive roles and cannot be saved</div>
              <div class="row mb-2">
                <div class="col-md-6 col-12">
                  <div>
                  <ValidationProvider name="Name" rules="required" v-slot="validation" immediate>
                    <b-form-group label="Notification Name">
                      <b-form-input
                        id="name"
                        class="form-control"
                        placeholder="Enter Name"
                        :state="spr2_getValidationState(validation)"
                        v-model="subscription.name"
                        aria-describedby="name-feedback"
                        size="lg"
                      />
                      <b-form-invalid-feedback id="name-feedback">{{ validation.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
              <hr />
              <div class="row mb-2 mt-5">
                <div class="col-md-4 col-6">
                  <div>
                    <h5>When a(n)</h5>
                    <b-form-select class="form-control" :options="subjectTypes" v-model="subscription.subjectType" @change="onSubjectChange"></b-form-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                    <template v-for="(filter, f_index) in subscription.filters">
                      <div :key="f_index" v-if="true">
                      <div>
                        <div>
                          <!--
                          <b-form-group v-if="filter.conditions.length > 1">
                            <b-form-radio v-model="filter.conditionsOperator" :name="`filters-operator-${f_index}`" value="OR" inline>Match <strong class="uppercase">ANY</strong> of the below</b-form-radio>
                            <b-form-radio v-model="filter.conditionsOperator" :name="`filters-operator-${f_index}`" value="AND" inline>Match <strong class="uppercase">ALL</strong> of the below</b-form-radio>
                          </b-form-group>
                          -->
                          <h5 class="mt-3">Conditions</h5>
                          <b-card>
                          <template v-for="(condition, c_index) in filter.conditions">
                            <div :key="c_index" v-if="true">
                              <div class="condition card p-3">
                                <div class="row no-gutters">
                                  <div class="col-xl-3 col-lg-4 col-md-6" v-if="subscription.subjectType == 'Event'">
                                    <!-- Action Type -->
                                    <b-form-group class="px-1" label="is">
                                      <b-form-select class="form-control" :options="actionTypes" v-model="condition.actionType" @change="onActionTypeChange(condition)"></b-form-select>
                                    </b-form-group>
                                  </div>
                                  <div class="col-xl-3 col-lg-4 col-md-6" v-if="subscription.subjectType == 'Property'">
                                    <!-- Property Action Type -->
                                    <b-form-group class="px-1" label="is">
                                      <b-form-select class="form-control" :options="propertyActionTypes" v-model="condition.actionType"></b-form-select>
                                    </b-form-group>
                                  </div>
                                  <div class="col-xl-3 col-lg-4 col-md-6" v-if="subscription.subjectType == 'RoutineTask'">
                                    <!-- Routine Task Action Type -->
                                    <b-form-group class="px-1" label="is">
                                      <b-form-select class="form-control" :options="routineTaskActionTypes" v-model="condition.actionType" @change="onRoutineTaskActionTypeChange(condition)"></b-form-select>
                                    </b-form-group>
                                  </div>
                                  <div class="col-xl-3 col-lg-4 col-md-6" v-if="subscription.subjectType == 'InsurancePolicy'">
                                    <!-- Insurance Policy Action Type -->
                                    <b-form-group class="px-1" label="is">
                                      <b-form-select class="form-control" :options="insurancePolicyActionTypes" v-model="condition.actionType" @change="onInsurancePolicyActionTypeChange(condition)"></b-form-select>
                                    </b-form-group>
                                  </div>
                                  <div class="col-xl-3 col-lg-4 col-md-6" v-if="subscription.subjectType == 'InsurancePolicy'">
                                    <!-- Policy Type Filter -->
                                    <b-form-group class="px-1" label="with a policy type of">
                                      <b-form-select class="form-control" :options="insurancePolicyTypes" v-model="condition.qualifier.policyType"></b-form-select>
                                    </b-form-group>
                                  </div>
                                  <div class="col-xl-4 col-lg-4 col-md-6" v-if="subscription.subjectType == 'InsurancePolicy' && condition.actionType == 'Updated'">
                                    <!-- Update Reason Filter: only shown for Updated action type -->
                                    <b-form-group class="px-1" label="caused by">
                                      <b-form-select class="form-control" :options="insurancePolicyUpdateReasons" v-model="condition.qualifier.updateReasonFilter"></b-form-select>
                                    </b-form-group>
                                  </div>
                                  <div class="col-xl-3 col-lg-4 col-md-6" v-if="subscription.subjectType == 'RoutineTask'">
                                    <!-- Schedule Type Filter -->
                                    <b-form-group class="px-1" label="with a schedule of">
                                      <b-form-select class="form-control" :options="routineTaskScheduleTypes" v-model="condition.qualifier.scheduleType"></b-form-select>
                                    </b-form-group>
                                  </div>
                                  <div class="col-xl-3 col-lg-4 col-md-6" v-if="subscription.subjectType == 'RoutineTask' && condition.actionType == 'StatusChanged'">
                                    <!-- Instance Status Filter -->
                                    <b-form-group class="px-1" label="changing to a status of">
                                      <b-form-select class="form-control" :options="routineTaskInstanceStatuses" v-model="condition.qualifier.instanceStatus"></b-form-select>
                                    </b-form-group>
                                  </div>
                                  <div class="col-xl-3 col-lg-4 col-md-6" v-if="subscription.subjectType == 'Event' && isChangeBasedEvent(condition)">
                                    <!-- Status Types -->
                                    <b-form-group class="px-1" label="with a status of">
                                      <b-form-select class="form-control" :options="eventStatusTypes" v-model="condition.qualifier.statusValue"></b-form-select>
                                    </b-form-group>
                                  </div>
                                  <div class="col-xl-3 col-lg-4 col-md-6" v-if="subscription.subjectType == 'Event'">
                                    <!-- Event Types -->
                                    <b-form-group class="px-1" :label="isChangeBasedEvent(condition)?'and type of':'with a type of'">
                                      <b-form-select class="form-control" :options="eventTypes" v-model="condition.qualifier.typeId" @change="onEventTypeChange(condition)"></b-form-select>
                                    </b-form-group>
                                  </div>
                                  <div class="col-xl-3 col-lg-4 col-md-6" v-if="subscription.subjectType == 'Event'">
                                    <!-- Event Categories -->
                                    <b-form-group class="px-1" label="and category of">
                                      <b-form-select class="form-control" :options="getEventTypeCategories(condition.qualifier.typeId)" v-model="condition.qualifier.categoryId" :disabled="condition.qualifier.typeId == null"></b-form-select>
                                    </b-form-group>
                                  </div>
                                  <div class="col-xl-3 col-lg-4 col-md-6" v-if="subscription.subjectType == 'Event'">
                                    <!-- Event Severity Level -->
                                    <b-form-group class="px-1" label="and severity of">
                                      <b-form-select class="form-control" :options="eventSeverityLevels" v-model="condition.qualifier.eventSeverityLevel"></b-form-select>
                                    </b-form-group>
                                  </div>
                                  <div class="col-xl-3 col-lg-4 col-md-6" v-if="subscription.subjectType == 'Event' && condition.actionType == 'TimeElapsed'">
                                    <!-- Delay Hours -->
                                    <b-form-group label="for">
                                      <b-input-group append="hour(s)">
                                        <b-form-input v-model="condition.delayHours" type="number" min="1" max="168" oninput="validity.valid||(value='');"></b-form-input>
                                      </b-input-group>
                                    </b-form-group>
                                  </div>
                                  <div class="col-xl-3 col-lg-4 col-md-6 d-flex" v-if="subscription.subjectType == 'Event' && condition.actionType == 'TimeElapsed'">
                                    <!-- Frequency Type -->
                                    <b-form-group class="d-flex align-items-end px-2 mb-3"><strong>;</strong></b-form-group>
                                    <b-form-group label="notify">
                                      <select class="form-control" v-model="condition.frequencyType">
                                          <option value="Once">Once</option>
                                          <option value="Hourly">Hourly</option>
                                          <option value="Daily">Daily</option>
                                          <option value="Weekly">Weekly</option>
                                          <option value="Monthly">Monthly</option>
                                      </select>
                                    </b-form-group>
                                  </div>
                                  <div class="col-xl-4 col-lg-4 col-md-6 d-flex" v-if="subscription.subjectType == 'RoutineTask' && condition.actionType == 'TimeElapsed'">
                                    <!-- Routine Task Overdue Delay + Frequency -->
                                    <b-form-group class="d-flex align-items-end px-2 mb-3"><strong>;</strong></b-form-group>
                                    <b-form-group label="hours past due">
                                      <select class="form-control" v-model.number="condition.delayHours">
                                        <option :value="0">Immediately</option>
                                        <option :value="4">4 hours</option>
                                        <option :value="8">8 hours</option>
                                        <option :value="24">1 day</option>
                                        <option :value="48">2 days</option>
                                      </select>
                                    </b-form-group>
                                    <b-form-group class="d-flex align-items-end px-2 mb-3"><strong>;</strong></b-form-group>
                                    <b-form-group label="notify">
                                      <select class="form-control" v-model="condition.frequencyType">
                                        <option value="Once">Once</option>
                                        <option value="Hourly">Hourly</option>
                                        <option value="Daily">Daily</option>
                                        <option value="Weekly">Weekly</option>
                                        <option value="Monthly">Monthly</option>
                                      </select>
                                    </b-form-group>
                                  </div>
                                  <div class="col-xl-4 col-lg-4 col-md-6 d-flex" v-if="subscription.subjectType == 'RoutineTask' && condition.actionType == 'DueSoon'">
                                    <!-- Routine Task Due Soon: hours before due + frequency -->
                                    <b-form-group class="d-flex align-items-end px-2 mb-3"><strong>;</strong></b-form-group>
                                    <b-form-group label="hours before due">
                                      <select class="form-control" v-model.number="condition.delayHours">
                                        <option :value="1">1 hour</option>
                                        <option :value="4">4 hours</option>
                                        <option :value="8">8 hours</option>
                                        <option :value="24">1 day</option>
                                        <option :value="48">2 days</option>
                                        <option :value="72">3 days</option>
                                        <option :value="168">1 week</option>
                                      </select>
                                    </b-form-group>
                                    <b-form-group class="d-flex align-items-end px-2 mb-3"><strong>;</strong></b-form-group>
                                    <b-form-group label="notify">
                                      <select class="form-control" v-model="condition.frequencyType">
                                        <option value="Once">Once</option>
                                        <option value="Daily">Daily</option>
                                      </select>
                                    </b-form-group>
                                  </div>
                                  <div class="col-xl-4 col-lg-4 col-md-6 d-flex" v-if="subscription.subjectType == 'InsurancePolicy' && condition.actionType == 'DueSoon'">
                                    <!-- Insurance Policy Expiring Soon: days before expiry + frequency -->
                                    <b-form-group class="d-flex align-items-end px-2 mb-3"><strong>;</strong></b-form-group>
                                    <b-form-group label="days before expiry">
                                      <select class="form-control" v-model.number="condition.delayHours">
                                        <option :value="720">30 days</option>
                                        <option :value="1440">60 days</option>
                                        <option :value="2160">90 days</option>
                                      </select>
                                    </b-form-group>
                                    <b-form-group class="d-flex align-items-end px-2 mb-3"><strong>;</strong></b-form-group>
                                    <b-form-group label="notify">
                                      <select class="form-control" v-model="condition.frequencyType">
                                        <option value="Once">Once</option>
                                        <option value="Daily">Daily</option>
                                        <option value="Weekly">Weekly</option>
                                      </select>
                                    </b-form-group>
                                  </div>
                                  <div class="col-xl-4 col-lg-4 col-md-6 d-flex" v-if="subscription.subjectType == 'InsurancePolicy' && condition.actionType == 'TimeElapsed'">
                                    <!-- Insurance Policy Expired: delay after expiry + frequency -->
                                    <b-form-group class="d-flex align-items-end px-2 mb-3"><strong>;</strong></b-form-group>
                                    <b-form-group label="days after expiry">
                                      <select class="form-control" v-model.number="condition.delayHours">
                                        <option :value="0">Immediately</option>
                                        <option :value="24">1 day</option>
                                        <option :value="72">3 days</option>
                                        <option :value="168">1 week</option>
                                      </select>
                                    </b-form-group>
                                    <b-form-group class="d-flex align-items-end px-2 mb-3"><strong>;</strong></b-form-group>
                                    <b-form-group label="notify">
                                      <select class="form-control" v-model="condition.frequencyType">
                                        <option value="Once">Once</option>
                                        <option value="Daily">Daily</option>
                                        <option value="Weekly">Weekly</option>
                                      </select>
                                    </b-form-group>
                                  </div>
                                  <div class="col-xl-3 col-lg-4 col-md-6" v-if="subscription.subjectType == 'InsuranceClaim'">
                                    <!-- Insurance Claim Action Type -->
                                    <b-form-group class="px-1" label="is">
                                      <b-form-select class="form-control" :options="insuranceClaimActionTypes" v-model="condition.actionType" @change="onInsuranceClaimActionTypeChange(condition)"></b-form-select>
                                    </b-form-group>
                                  </div>
                                  <div class="col-xl-3 col-lg-4 col-md-6" v-if="subscription.subjectType == 'InsuranceClaim'">
                                    <!-- Insurance Claim Type Filter -->
                                    <b-form-group class="px-1" label="of type">
                                      <b-form-select class="form-control" :options="insuranceClaimTypes" v-model="condition.qualifier.claimType"></b-form-select>
                                    </b-form-group>
                                  </div>
                                  <div class="col-xl-3 col-lg-4 col-md-6" v-if="subscription.subjectType == 'InsuranceClaim' && condition.actionType == 'StatusChanged'">
                                    <!-- Insurance Claim Target Status Filter (StatusChanged only) -->
                                    <b-form-group class="px-1" label="changing to">
                                      <b-form-select class="form-control" :options="insuranceClaimStatusTypes" v-model="condition.qualifier.targetStatus"></b-form-select>
                                    </b-form-group>
                                  </div>
                                  <div class="col-xl-4 col-lg-4 col-md-6 d-flex" v-if="subscription.subjectType == 'InsuranceClaim' && condition.actionType == 'TimeElapsed'">
                                    <!-- Stale Claim: hours without status change + frequency -->
                                    <b-form-group class="d-flex align-items-end px-2 mb-3"><strong>;</strong></b-form-group>
                                    <b-form-group label="hours without status change">
                                      <select class="form-control" v-model.number="condition.delayHours">
                                        <option :value="24">24 (1 day)</option>
                                        <option :value="48">48 (2 days)</option>
                                        <option :value="72">72 (3 days)</option>
                                        <option :value="168">168 (1 week)</option>
                                        <option :value="336">336 (2 weeks)</option>
                                      </select>
                                    </b-form-group>
                                    <b-form-group class="d-flex align-items-end px-2 mb-3"><strong>;</strong></b-form-group>
                                    <b-form-group label="notify">
                                      <select class="form-control" v-model="condition.frequencyType">
                                        <option value="Once">Once</option>
                                        <option value="Daily">Daily</option>
                                        <option value="Weekly">Weekly</option>
                                      </select>
                                    </b-form-group>
                                  </div>
                                  <!-- Add Condition -->
                                  <div class="right align-self-center mt-3" v-if="filter.conditions.length > 1 || (subscription.filters.length > 1)">
                                    <div>
                                      <i class="fas fa-trash text-danger" @click="removeCondition(f_index, c_index)"></i>
                                    </div>
                                  </div>
                                </div>
                                <div class="row mb-n4" v-if="c_index == filter.conditions.length-1">
                                  <div class="col-12 text-center">
                                    <b-button @click="addCondition(f_index)" variant="success"><i class="fas fa-plus mr-2"></i>Add Condition</b-button>
                                  </div>
                                </div>
                              </div>
                              <div v-if="c_index != filter.conditions.length-1">
                                <div class="condition-separator">
                                  <div class="condition-separator-operator" vx-text="filter.conditionsOperator">OR</div>
                                </div>
                              </div>
                            </div>
                          </template>
                          </b-card>
                          <h5 class="mt-5">Location Conditions</h5>
                          <b-card>
                            <div class="row" v-if="filter.locations.length == 0">
                              <div class="col-12 text-center">
                                <b-button @click="addLocationCondition(f_index)" variant="success"><i class="fas fa-plus mr-2"></i>Add Location Condition </b-button>
                              </div>
                            </div>
                            <template v-for="(location, l_index) in filter.locations">
                              <div :key="l_index" v-if="true">
                                <div class="condition card p-3">
                                  <div class="row no-gutters">
                                    <div class="col-xl-4 col-lg-4 col-md-6" v-if="subscription.subjectType == 'Event' || subscription.subjectType == 'Property' || subscription.subjectType == 'RoutineTask' || subscription.subjectType == 'InsurancePolicy' || subscription.subjectType == 'InsuranceClaim'">
                                      <!-- Location Type -->
                                      <b-form-group class="px-1" label="has a location type of">
                                        <select class="form-control" v-model="location.locationConditionType" @change="onLocationConditionTypeChange(location, l_index, f_index)">
                                            <option value="Property" v-if="subscription.subjectType == 'Event' || subscription.subjectType == 'RoutineTask' || subscription.subjectType == 'InsurancePolicy' || subscription.subjectType == 'InsuranceClaim'">Property</option>
                                            <option value="PropertyGroup" v-if="subscription.subjectType == 'Event' || subscription.subjectType == 'RoutineTask' || subscription.subjectType == 'InsurancePolicy' || subscription.subjectType == 'InsuranceClaim'">Property Group</option>
                                            <option value="State">State</option>
                                        </select>
                                      </b-form-group>
                                    </div>
                                    <div class="col-8" v-if="(subscription.subjectType == 'Event' || subscription.subjectType == 'RoutineTask' || subscription.subjectType == 'InsurancePolicy' || subscription.subjectType == 'InsuranceClaim') && location.locationConditionType == 'Property'">
                                      <!-- Location Type: Property -->
                                      <b-form-group class="px-1" label="with properties">
                                      <ValidationProvider name="Property" rules="required" v-slot="validation" immediate>
                                        <b-form-select class="form-control" :options="properties" v-model="location.propertyIds" multiple :state="spr2_getValidationState(validation)"></b-form-select>
                                      </ValidationProvider>
                                      </b-form-group>
                                    </div>
                                    <div class="col-8" v-if="(subscription.subjectType == 'Event' || subscription.subjectType == 'RoutineTask' || subscription.subjectType == 'InsurancePolicy' || subscription.subjectType == 'InsuranceClaim') && location.locationConditionType == 'PropertyGroup'">
                                      <!-- Location Type: Property Groups -->
                                      <b-form-group class="px-1" label="with property groups">
                                      <ValidationProvider name="Property Groups" rules="required" v-slot="validation" immediate>
                                        <b-form-select class="form-control" :options="propertyGroups" v-model="location.propertyGroupIds" multiple :state="spr2_getValidationState(validation)"></b-form-select>
                                      </ValidationProvider>
                                      </b-form-group>
                                    </div>
                                    <div class="col-xl-4 col-lg-4 col-md-6" v-if="(subscription.subjectType == 'Event' || subscription.subjectType == 'Property' || subscription.subjectType == 'RoutineTask' || subscription.subjectType == 'InsurancePolicy' || subscription.subjectType == 'InsuranceClaim') && location.locationConditionType == 'State'">
                                      <!-- Location Type: State -->
                                      <b-form-group class="px-1" label="in the state(s) of">
                                      <ValidationProvider name="Property" rules="required" v-slot="validation" immediate>
                                        <b-form-select class="px-1" :options="states" v-model="location.stateAbbreviations" multiple :state="spr2_getValidationState(validation)"></b-form-select>
                                      </ValidationProvider>
                                      </b-form-group>
                                    </div>
                                    <!-- Add Condition -->
                                    <div class="right align-self-center mt-3">
                                      <div>
                                        <i class="fas fa-trash text-danger" @click="removeLocationCondition(f_index, l_index)"></i>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row mb-n4" v-if="l_index == filter.locations.length-1">
                                    <div class="col-12 text-center">
                                      <b-button @click="addLocationCondition(f_index)" variant="success"><i class="fas fa-plus mr-2"></i>Add Location Condition </b-button>
                                    </div>
                                  </div>
                                </div>
                                <div v-if="l_index != filter.locations.length-1">
                                  <div class="condition-separator">
                                    <div class="condition-separator-operator" vx-text="filter.conditionsOperator">OR</div>
                                  </div>
                                </div>
                              </div>
                            </template>
                          </b-card>
                        </div>
                      </div>
                      <div class="toggle-container d-flex flex-column justify-content-center" v-if="subscription.filters.length <= 2 && false">
                          <div class="vertical-line" v-if="f_index == 0"></div>
                          <div class="d-flex justify-content-center">
                            <b-button variant="primary" @click="addFilter" v-if="subscription.filters.length == 1 && f_index == 0"><i class="fas fa-plus-circle mr-2"></i>Add Filter</b-button>
                            <b-tabs pills v-if="subscription.filters.length == 2 && f_index == 0">
                              <b-tab title="AND" active><b-card-text></b-card-text></b-tab>
                              <b-tab title="OR"><b-card-text></b-card-text></b-tab>
                            </b-tabs>
                          </div>
                          <div class="vertical-line" v-if="subscription.filters.length == 2 && f_index == 0"></div>
                      </div>
                      </div>
                    </template>
                </div>
              </div>
              <h5 class="mt-5">Subscribers</h5>
              <b-card>
              <div class="row" v-for="(subscriber, index) in subscription.subscribers" :key="index">
                <div class="col-12">
                  <div class="condition card p-3 mb-3">
                    <div class="row no-gutters">
                      <div class="col-xl-3 col-lg-4 col-md-6">
                        <b-form-group label="Notify" class="px-1">
                          <select class="form-control" v-model="subscriber.recipientType" @change="onRecipientTypeChange(subscriber)" >
                              <option value="Person">Person</option>
                              <option value="Role">Role</option>
                              <!--<option value="Vendor">Vendor</option>-->
                          </select>
                        </b-form-group>
                      </div>
                      <div class="col-xl-4 col-lg-4 col-md-6" v-if="subscriber.recipientType == 'Person'">
                        <!-- Person -->
                        <b-form-group label="with a name of" class="px-1">
                          <ValidationProvider name="Person" rules="required" v-slot="validation" immediate>
                          <b-form-select class="form-controlx" :options="people" v-model="subscriber.recipientQualifier" :state="spr2_getValidationState(validation)"></b-form-select>
                          </ValidationProvider>
                          <!--<multiselect v-model="subscriber.recipientQualifier" :options="people" track-by="value" label="text" placeholder="Search...">
                            <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
                          </multiselect>-->
                        </b-form-group>
                      </div>
                      <div class="col-xl-4 col-lg-4 col-md-6" v-if="subscriber.recipientType == 'Role'">
                        <!-- Role -->
                        <b-form-group label="with a name of" class="px-1">
                          <ValidationProvider name="Role" rules="required" v-slot="validation" immediate>
                            <b-form-select aria-describedby="person-feedback" class="px-1" :state="spr2_getValidationState(validation)" :options="roles" v-model="subscriber.recipientQualifier"></b-form-select>
                          </ValidationProvider>
                        </b-form-group>
                      </div>
                      <div class="col-xl-4 col-lg-4 col-md-6" v-if="subscriber.recipientType == 'Vendor'" >
                        <!-- Vendor -->
                        <b-form-group label="with a name of" class="px-1">
                          <ValidationProvider name="Role" rules="required" v-slot="validation" immediate>
                          <b-form-select class="form-control" :options="vendors" v-model="subscriber.recipientQualifier" :state="spr2_getValidationState(validation)"></b-form-select>
                          </ValidationProvider>
                        </b-form-group>
                      </div>
                      <div class="col-xl-4 col-lg-4 col-md-6">
                        <b-form-group label="by">
                          <select class="form-control" v-model="subscriber.mediaType">
                              <option value="Email">Email</option>
                              <option value="Text">Text</option>
                          </select>
                        </b-form-group>
                      </div>
                      <div class="right align-self-center mt-3" v-if="subscription.subscribers.length > 1">
                        <div class="p-4">
                          <i class="fas fa-trash text-danger" @click="removeSubscriber(index)"></i>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-n4" v-if="index == subscription.subscribers.length-1">
                      <div class="col-12 text-center">
                        <b-button @click="addSubscriber()" variant="success"><i class="fas fa-plus mr-2"></i>Add Subscriber</b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </b-card>
            </div>
            <div class="col-md-3 p-0 order-md-2 order-1 p-absolute" style="right:0;">
              <div class="alert alert-info  notification-scroller overflow-auto">
                <h6 class="mb-4 mt-3">Notification Preview</h6>
                <span v-html="getDescription(subscription)"></span>
                </div>
            </div>
        </div>
      </div>
      </b-form>
    </ValidationObserver>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { spr2Validation } from '../../mixins/Spr2SharedFunctions'

export default {
  mixins: [spr2Validation],
  name: 'Subscriptions',
  data () {
    return {
      showDescription: true,
      loading: false,
      people: [],
      roles: [],
      eventTypes: [],
      properties: [],
      propertyGroups: [],
      states: [],
      subscription: {
        id: null,
        lastSentUtc: null,
        subjectType: 'Event',
        filtersOperator: 'OR',
        filters: [
          {
            // conditionsOperator: 'OR',
            conditions: [
              {
                actionType: 'TimeElapsed',
                delayHours: 1,
                frequencyType: 'Once',
                qualifier: {
                  type: 'StatusTypeAndCategory',
                  typeId: null,
                  categoryId: null,
                  statusValue: null,
                  qualifierSubjectType: 'Event',
                  eventSeverityLevel: 'Low'
                }
              }
            ],
            locations: []
          }
        ],
        subscribers: [
          {
            recipientQualifier: null,
            recipientType: 'Role',
            mediaType: 'Email'
          }
        ]
      },
      // Lookup values
      actionTypes: [
        { value: 'Created', text: 'Created' },
        { value: 'Deleted', text: 'Deleted' },
        { value: 'StatusChanged', text: 'Changed' },
        { value: 'TimeElapsed', text: 'Unchanged' }
      ],
      propertyActionTypes: [
        { value: 'Created', text: 'Created' },
        { value: 'Updated', text: 'Updated' },
        { value: 'Deleted', text: 'Archived' }
      ],
      eventQualifierTypes: [
        { value: 'Status', text: 'Status' },
        { value: 'TypeAndCategory', text: 'Type' },
        { value: 'StatusTypeAndCategory', text: 'Status and Type' }
      ],
      eventStatusTypes: [
        { value: null, text: 'Any' },
        { value: 'New', text: 'New' },
        { value: 'InProgress', text: 'In Progress' },
        { value: 'PendingApproval', text: 'Pending Approval' },
        { value: 'Approved', text: 'Approved' },
        { value: 'Complete', text: 'Complete' },
        { value: 'ReportInProgress', text: 'SOP In Progress' },
        { value: 'ClaimInProgress', text: 'Claim In Progress' }
      ],
      eventSeverityLevels: [
        {value: 'Low', text: 'High and Low'},
        {value: 'High', text: 'High'}
      ],
      routineTaskActionTypes: [
        { value: 'Created', text: 'Created' },
        { value: 'Updated', text: 'Updated' },
        { value: 'Deleted', text: 'Deleted' },
        { value: 'StatusChanged', text: 'Status Changed' },
        { value: 'DueSoon', text: 'Due Soon' },
        { value: 'TimeElapsed', text: 'Overdue' }
      ],
      routineTaskScheduleTypes: [
        { value: null, text: 'Any' },
        { value: 'AdHoc', text: 'Ad Hoc' },
        { value: 'Daily', text: 'Daily' },
        { value: 'Weekly', text: 'Weekly' },
        { value: 'Monthly', text: 'Monthly' },
        { value: 'Quarterly', text: 'Quarterly' }
      ],
      routineTaskInstanceStatuses: [
        { value: null, text: 'Any' },
        { value: 'NotStarted', text: 'Not Started' },
        { value: 'InProgress', text: 'In Progress' },
        { value: 'Blocked', text: 'Blocked' },
        { value: 'Complete', text: 'Complete' }
      ],
      insurancePolicyActionTypes: [
        { value: 'Created', text: 'Created' },
        { value: 'Updated', text: 'Updated' },
        { value: 'Deleted', text: 'Archived' },
        { value: 'DueSoon', text: 'Expiring Soon' },
        { value: 'TimeElapsed', text: 'Expired' }
      ],
      insurancePolicyTypes: [
        { value: null, text: 'Any' },
        { value: 'GeneralLiability', text: 'General Liability' },
        { value: 'Umbrella', text: 'Umbrella' },
        { value: 'PropertyAndCasualty', text: 'Property and Casualty' }
      ],
      insurancePolicyUpdateReasons: [
        { value: null,                   text: 'Any' },
        { value: 'PolicyDetailsChanged', text: 'Policy details changed (carrier, premium, dates, coverage)' },
        { value: 'ClaimCountChanged',    text: 'Claim filed or removed against this policy' }
      ],
      insuranceClaimActionTypes: [
        { value: 'Created',       text: 'Created' },
        { value: 'Updated',       text: 'Updated' },
        { value: 'StatusChanged', text: 'Status Changed' },
        { value: 'Deleted',       text: 'Archived' },
        { value: 'TimeElapsed',   text: 'Unchanged' }
      ],
      insuranceClaimTypes: [
        { value: null,                text: 'Any' },
        { value: 'PropertyLiability', text: 'Property Liability' },
        { value: 'ResidentLiability', text: 'Resident Liability' },
        { value: 'PropertyCasualty',  text: 'Property Casualty' },
        { value: 'VendorLiability',   text: 'Vendor Liability' }
      ],
      insuranceClaimStatusTypes: [
        { value: null,                        text: 'Any' },
        { value: 'New',                       text: 'New' },
        { value: 'UnderReview',               text: 'Under Review' },
        { value: 'InLitigation',              text: 'In Litigation' },
        { value: 'PendingClaimNumber',        text: 'Pending Claim Number' },
        { value: 'PendingEstimates',          text: 'Pending Estimates' },
        { value: 'PendingPaymentSettled',     text: 'Pending Payment Settled' },
        { value: 'PendingRepairsPaid',        text: 'Pending Repairs Paid' },
        { value: 'ClosedDenied',              text: 'Closed — Denied' },
        { value: 'ClosedPaid',                text: 'Closed — Paid' },
        { value: 'ClosedResidentOutOfPocket', text: 'Closed — Resident Out of Pocket' },
        { value: 'ClosedUncollected',         text: 'Closed — Uncollected' }
      ],
      locationConditionTypes: [
        { value: 'Property', text: 'Property' },
        { value: 'PropertyGroup', text: 'Property Group' },
        { value: 'State', text: 'State' }
      ],
      vendorList: []
    }
  },
  async created () {
    this.loading = true
    await this.doLoadPeople()
    await this.doLoadPositionTypes()
    // await this.getVendors().then(r => {
    //   console.log('Vendor list returned: ', r.data.vendors)
    //   this.vendorList = r.data.vendors
    // })
    await this.doLoadEventTypes()
    await this.doLoadSubscription()
    await this.doLoadProperties()
    await this.doLoadPropertyGroups()
    await this.doLoadStates()
    this.loading = false
  },
  computed: {
    subjectTypes () {
      return [
        { value: 'Event', text: 'Event', enabled: true },
        { value: 'Property', text: 'Property', enabled: this.$store.getters['featureFlags/isEnabled']('subscription.selection.property') },
        { value: 'RoutineTask', text: 'Routine Task', enabled: this.$store.getters['featureFlags/isEnabled']('subscription.selection.routinetask') },
        { value: 'InsurancePolicy', text: 'Insurance Policy', enabled: this.$store.getters['featureFlags/isEnabled']('subscription.selection.insurancepolicy') },
        { value: 'InsuranceClaim', text: 'Insurance Claim', enabled: this.$store.getters['featureFlags/isEnabled']('subscription.selection.insuranceclaim') }
        // { value: 'PropertyGroup', text: 'Property Group' }
        // { value: 'Document', text: 'Document' }
        // { value: 'Vendor', text: 'Vendor' }
      ].filter(t => t.enabled).map(({ value, text }) => ({ value, text }))
    },
    vendors () {
      let v = this.vendorList.map((p) => { return { text: p.name, value: p.id } })
      // Splice in a disabled default option
      v.splice(0, 0, {text: 'Select a Vendor to Notify', value: null, disabled: true})
      return v
    },
    subscriptionId () {
      return this.$route.params.id === 'new' ? null : this.$route.params.id
    },
    hasInactiveRolesAssigned () {
      let inactiveRoleIds = this.roles.filter(r => r.active === false).map(r => r.value)
      let hasInactiveRoleSubscribers = inactiveRoleIds.length > 0 && this.subscription.subscribers.some(s => inactiveRoleIds.includes(s.recipientQualifier))
      return hasInactiveRoleSubscribers
    }
  },
  methods: {
    ...mapActions('events', ['getEventTypes']),
    ...mapActions('company', ['getPeopleForManagement', 'getPositionTypes', 'getVendors', 'getProperties', 'getPropertyGroups']),
    ...mapActions('companyNotifications', ['saveSubscription', 'getSubscription']),
    ...mapActions('lookups', ['getLookupStates']),
    customLabel ({text, value}) {
      console.log('DATA', text, value)
      return text
    },
    isChangeBasedEvent (condition) {
      return (condition.actionType === 'TimeElapsed' || condition.actionType === 'StatusChanged')
    },
    getDescription (subscription) {
      const isRoutineTask = subscription.subjectType === 'RoutineTask'
      const isProperty = subscription.subjectType === 'Property'
      const isInsurancePolicy = subscription.subjectType === 'InsurancePolicy'
      const isInsuranceClaim = subscription.subjectType === 'InsuranceClaim'
      const article = isProperty || isRoutineTask || isInsurancePolicy ? 'a' : 'an'
      const subjectDisplay = isRoutineTask ? 'Routine Task' : isInsurancePolicy ? 'Insurance Policy' : isInsuranceClaim ? 'Insurance Claim' : subscription.subjectType
      let text = ''
      text = `When ${article} ${this.wrapText(subjectDisplay)}`
      subscription.filters.forEach((filter) => {
        filter.conditions.forEach((condition, cIndex) => {
          if (cIndex > 0) {
            text += `<br /><hr />or ${article} ${this.wrapText(subjectDisplay)}`
          }
          // Qualifiers that appear BEFORE the action verb
          if (isInsurancePolicy) {
            let policyType = this.insurancePolicyTypes.find(p => p.value === condition.qualifier.policyType)
            if (policyType) {
              text += ` with a policy type of ${this.wrapText(policyType.text)}`
            }
            // Update reason filter (Updated only) — rendered before the action verb
            if (condition.actionType === 'Updated') {
              let reason = this.insurancePolicyUpdateReasons.find(r => r.value === condition.qualifier.updateReasonFilter)
              if (reason) {
                text += ` and caused by ${this.wrapText(reason.text)}`
              }
            }
          }
          if (isRoutineTask) {
            let scheduleType = this.routineTaskScheduleTypes.find(s => s.value === condition.qualifier.scheduleType)
            if (scheduleType) {
              text += ` with a schedule of ${this.wrapText(scheduleType.text)}`
            }
          }
          if (isInsuranceClaim) {
            // Claim type qualifier — rendered before the action verb
            let claimType = this.insuranceClaimTypes.find(t => t.value === condition.qualifier.claimType)
            if (claimType) {
              text += ` of type ${this.wrapText(claimType.text)}`
            }
            // StatusChanged: target status — rendered before the action verb
            if (condition.actionType === 'StatusChanged') {
              let status = this.insuranceClaimStatusTypes.find(s => s.value === condition.qualifier.targetStatus)
              if (status) {
                text += ` and status changing to ${this.wrapText(status.text)}`
              }
            }
            // TimeElapsed: stale duration + frequency — rendered before the action verb
            if (condition.actionType === 'TimeElapsed') {
              let delayHours = condition.delayHours
              let frequency = condition.frequencyType
              if (delayHours !== null && delayHours > 0) {
                text += `; ${this.wrapText(delayHours)} hour(s) without status change`
              }
              if (frequency !== null) {
                text += `; notify ${this.wrapText(frequency)}`
              }
            }
          }

          // Action Type
          let actionTypesList = isProperty ? this.propertyActionTypes
            : isRoutineTask ? this.routineTaskActionTypes
            : isInsurancePolicy ? this.insurancePolicyActionTypes
            : isInsuranceClaim ? this.insuranceClaimActionTypes
            : this.actionTypes
          let actionType = actionTypesList.find((item, index) => { return item.value === condition.actionType })
          if (actionType !== undefined && actionType.value !== null) {
            const verb = isInsuranceClaim && condition.actionType === 'StatusChanged' ? 'has its' : 'is'
            text += ` ${verb} ${this.wrapText(actionType.text)}`
          }

          if (!isProperty && !isRoutineTask && !isInsurancePolicy) {
            // Status
            let status = this.eventStatusTypes.find((item, index) => { return item.value === condition.qualifier.statusValue })
            if (status !== undefined && this.isChangeBasedEvent(condition)) {
              text += ` with a status of ${this.wrapText(status.text)}`
            }

            // Type
            let type = this.eventTypes.find((item, index) => { return item.value === condition.qualifier.typeId })
            if (type !== undefined) {
              if (this.isChangeBasedEvent(condition)) {
                text += `, a type of ${this.wrapText(type.text)}`
              } else {
                text += ` with a type of ${this.wrapText(type.text)}`
              }
            }

            // Category
            let categories = this.getEventTypeCategories(condition.qualifier.typeId)
            let category = categories.find((item, index) => { return item.value === condition.qualifier.categoryId })
            if (category !== undefined && this.isChangeBasedEvent(condition)) {
              text += `, a category of ${this.wrapText(category.text)}`
            }

            // Severity Level
            let eventSeverityLevel = this.eventSeverityLevels.find((item, index) => { return item.value === condition.qualifier.eventSeverityLevel })
            if (eventSeverityLevel !== undefined) {
              text += `, and a severity level of ${this.wrapText(eventSeverityLevel.text)}`
            }
          }

          if (isRoutineTask) {
            // Instance status filter (StatusChanged only) — appears after the verb
            if (condition.actionType === 'StatusChanged') {
              let instanceStatus = this.routineTaskInstanceStatuses.find(s => s.value === condition.qualifier.instanceStatus)
              if (instanceStatus) {
                text += ` changing to a status of ${this.wrapText(instanceStatus.text)}`
              }
            }
          }

          // Delay Hours / Frequency
          let delayHours = condition.delayHours
          let frequency = condition.frequencyType
          if (isRoutineTask && condition.actionType === 'TimeElapsed') {
            // Overdue: skip the delay phrase when delayHours == 0 (notify immediately)
            if (delayHours !== null && delayHours > 0) {
              text += `; ${this.wrapText(delayHours)} hour(s) past due`
            }
            if (frequency !== null) {
              text += `; notify ${this.wrapText(frequency)}`
            }
          } else if (isRoutineTask && condition.actionType === 'DueSoon') {
            if (delayHours !== null) {
              text += `; ${this.wrapText(delayHours)} hour(s) before due`
            }
            if (frequency !== null) {
              text += `; notify ${this.wrapText(frequency)}`
            }
          } else if (isInsurancePolicy && condition.actionType === 'DueSoon') {
            if (delayHours !== null) {
              const days = Math.round(delayHours / 24)
              text += `; ${this.wrapText(days)} day(s) before expiry`
            }
            if (frequency !== null) {
              text += `; notify ${this.wrapText(frequency)}`
            }
          } else if (isInsurancePolicy && condition.actionType === 'TimeElapsed') {
            if (delayHours !== null) {
              if (delayHours === 0) {
                text += `; ${this.wrapText('Immediately')} after expiry`
              } else {
                const days = Math.round(delayHours / 24)
                text += `; ${this.wrapText(days)} day(s) after expiry`
              }
            }
            if (frequency !== null) {
              text += `; notify ${this.wrapText(frequency)}`
            }
          } else if (isInsuranceClaim && condition.actionType === 'TimeElapsed') {
            // already rendered before the action verb
          } else if (this.isChangeBasedEvent(condition)) {
            if (delayHours !== null) {
              text += ` for ${this.wrapText(delayHours)} hour(s)`
            }
            if (frequency !== null) {
              text += `; notify ${this.wrapText(frequency)}`
            }
          }
        })

        filter.locations.forEach((location, locIndex) => {
          const locArticle = isProperty ? 'the' : isInsurancePolicy || isInsuranceClaim ? 'an' : 'a'
          if (locIndex === 0) {
            text += `<br /><hr />and ${locArticle} ${this.wrapText(subjectDisplay)}`
          } else {
            text += `<br /><hr />or ${locArticle} ${this.wrapText(subjectDisplay)}`
          }
          // Location Condition Type
          let locationConditionType = this.locationConditionTypes.find((item, index) => { return item.value === location.locationConditionType })
          if (locationConditionType !== undefined && locationConditionType.value !== null) {
            if (locationConditionType.value === 'Property' && location.propertyIds !== []) {
              // Properties
              text += ` occurs at the ${this.wrapText(locationConditionType.text)} of`
              let props = []
              location.propertyIds.forEach((propertyId) => {
                let property = this.properties.find((item) => { return item.value === propertyId })
                props.push(property.text)
              })
              text += ` ${this.wrapText(props.join(', ').replace(/,([^,]*)$/, ', or $1'))}`
            }

            if (locationConditionType.value === 'PropertyGroup' && location.propertyGroupIds !== []) {
              // Property Groups
              text += ` occurs in the ${this.wrapText(locationConditionType.text)} of`
              let propGroups = []
              location.propertyGroupIds.forEach((propertyGroupId) => {
                let propertyGroup = this.propertyGroups.find((item) => { return item.value === propertyGroupId })
                propGroups.push(propertyGroup.text)
              })
              text += ` ${this.wrapText(propGroups.join(', ').replace(/,([^,]*)$/, ', or $1'))}`
            }

            if (locationConditionType.value === 'State' && location.stateAbbreviations !== null) {
              // States — phrasing differs: Event/RoutineTask "occurs at a property in", Property just "in"
              if (isProperty) {
                text += ` is located in the ${this.wrapText(locationConditionType.text + '(s)')} of`
              } else {
                text += ` occurs at a property in the ${this.wrapText(locationConditionType.text + '(s)')} of`
              }
              let states = []
              location.stateAbbreviations.forEach((abbrev) => {
                let state = this.states.find((item) => { return item.value === abbrev })
                states.push(state.text)
              })
              text += ` ${this.wrapText(states.join(', ').replace(/,([^,]*)$/, ', or $1'))}`
            }
          }
        })
        this.subscription.subscribers.forEach((subscriber, subIndex) => {
          if (subscriber.recipientQualifier != null) {
            let notify = subIndex === 0 ? '<hr />Notify' : '<hr /> and'

            if (subscriber.recipientType === 'Role') {
              let role = this.roles.find((item, index) => { return item.value === subscriber.recipientQualifier })
              text += ` ${notify} people in the ${this.wrapText(subscriber.recipientType)} of ${this.wrapText(role.text)} by ${this.wrapText(subscriber.mediaType)}<br />`
            } else if (subscriber.recipientType === 'Person') {
              let person = this.people.find((item, index) => { return item.value === subscriber.recipientQualifier })
              text += ` ${notify} ${this.wrapText(person.text)} by ${this.wrapText(subscriber.mediaType)} <br />`
            }
          }
        })
      })
      return text
    },
    wrapText (text) {
      return `<strong style="color: black">${text}</strong>`
    },
    async doSaveSubscription () {
      console.log(JSON.stringify(this.subscription, null, 2))
      await this.saveSubscription(this.subscription).then(() => {
        this.$router.push('/notifications')
        this.$toasted.show('Subscription saved.', { duration: 4000 })
      }).catch(() => {
        this.$toasted.error('Subscription could not be saved.', { duration: 4000 })
      })
    },
    async doLoadSubscription () {
      if (this.subscriptionId) {
        await this.getSubscription(this.subscriptionId).then(r => { this.subscription = r })
      }
    },
    async doLoadPeople () {
      await this.getPeopleForManagement(false).then(r => {
        this.people = r.data.people.map((p) => { return { text: `${p.firstName} ${p.lastName}`, value: p.id } })
        // Splice in a disabled default option
        this.people.splice(0, 0, {text: 'Select a Person to Notify', value: null, disabled: true, $isDisabled: true})
        /*
        // Or use this in the template
          <template #first>
            <b-form-select-option value="null">Select a Person to Notify</b-form-select-option>
          </template>
        */
      })
    },
    async doLoadPositionTypes () {
      await this.getPositionTypes(false).then(r => {
        this.roles = r.data.types.filter(p => this.subscriptionId === null ? p.active : true).map((p) => { return { text: p.active ? p.name : p.name + ' (inactive)', value: p.id, active: p.active, disabled: !p.active } })
        console.log('roles', this.roles)
        // Splice in a disabled default option
        this.roles.splice(0, 0, {text: 'Select a Role to Notify', value: null, disabled: true})
      })
    },
    async doLoadEventTypes () {
      await this.getEventTypes(false).then(r => {
        this.eventTypes = r.data.eventTypes.map((e) => {
          return {
            text: e.name,
            value: e.id,
            categories: e.categories.map((c) => { return { value: c.id, text: c.name } })
          }
        })
        console.log('event types', this.eventTypes)
        // Splice in a disabled default option
        this.eventTypes.splice(0, 0, {text: 'Any', value: null})
      })
    },
    async doLoadProperties () {
      await this.getProperties(false).then(r => {
        this.properties = r.data.properties.map((p) => { return { text: `${p.name}`, value: p.id } })
        this.propertyIds = r.data.properties.map((p) => { return p.id })

        // Splice in a disabled default option
        this.properties.splice(0, 0, {text: 'Select one or more properties', value: null, disabled: true, $isDisabled: true})
        /*
        // Or use this in the template
          <template #first>
            <b-form-select-option value="null">Select a Person to Notify</b-form-select-option>
          </template>
        */
      })
    },
    async doLoadPropertyGroups () {
      await this.getPropertyGroups(false).then(r => {
        this.propertyGroups = r.data.propertyGroups.map((p) => { return { text: `${p.name}`, value: p.id } })
        // this.propertyIds = r.data.propertyGroups.map((p) => { return p.id })

        // Splice in a disabled default option
        this.propertyGroups.splice(0, 0, {text: 'Select one or more properties', value: null, disabled: true, $isDisabled: true})
        /*
        // Or use this in the template
          <template #first>
            <b-form-select-option value="null">Select a Person to Notify</b-form-select-option>
          </template>
        */
      })
    },
    async doLoadStates () {
      await this.getLookupStates(false).then(r => {
        this.states = r.data.states.map((p) => { return { text: `${p.name}`, value: p.abbreviation } })

        // Splice in a disabled default option
        this.states.splice(0, 0, {text: 'Select a State', value: null, disabled: true, $isDisabled: true})
        /*
        // Or use this in the template
          <template #first>
            <b-form-select-option value="null">Select a Person to Notify</b-form-select-option>
          </template>
        */
      })
    },
    getEventTypeCategories (eventTypeId) {
      let categories = []
      if (eventTypeId != null) {
        let evt = this.eventTypes.find((e) => e.value === eventTypeId)
        if (evt != null) {
          categories = evt.categories.map((c) => { return { value: c.value, text: c.text } })
        }
      }
      categories.splice(0, 0, {text: 'Any', value: null})
      return categories
    },
    addCondition (filterIndex) {
      let filter = this.subscription.filters[filterIndex]

      let c = this.subscription.subjectType === 'Property'
        ? {
            actionType: 'Created',
            frequencyType: null,
            delayHours: null,
            qualifier: { type: 'PropertyQualifier', qualifierSubjectType: 'Property' }
          }
        : this.subscription.subjectType === 'RoutineTask'
        ? {
            actionType: 'Created',
            frequencyType: null,
            delayHours: null,
            qualifier: {
              type: 'RoutineTaskQualifier',
              qualifierSubjectType: 'RoutineTask',
              scheduleType: null,
              instanceStatus: null
            }
          }
        : this.subscription.subjectType === 'InsurancePolicy'
        ? {
            actionType: 'Created',
            frequencyType: null,
            delayHours: null,
            qualifier: {
              type: 'InsurancePolicyQualifier',
              qualifierSubjectType: 'InsurancePolicy',
              policyType: null,
              lineOfCoverageId: null,
              updateReasonFilter: null
            }
          }
        : this.subscription.subjectType === 'InsuranceClaim'
        ? {
            actionType: 'Created',
            frequencyType: null,
            delayHours: null,
            qualifier: {
              type: 'InsuranceClaimQualifier',
              qualifierSubjectType: 'InsuranceClaim',
              claimType: null,
              targetStatus: null
            }
          }
        : {
            actionType: 'Created',
            frequencyType: null,
            delayHours: null,
            qualifier: {
              type: 'StatusTypeAndCategory',
              typeId: null,
              categoryId: null,
              statusValue: null,
              qualifierSubjectType: 'Event',
              eventSeverityLevel: 'Low'
            }
          }

      filter.conditions.push(c)
      console.log(filter.conditions)
    },
    removeCondition (filterIndex, conditionIndex) {
      let filter = this.subscription.filters[filterIndex]
      filter.conditions.splice(conditionIndex, 1)
      if (filter.conditions.length === 0) {
        this.subscription.filters.splice(filterIndex, 1)
      }
    },
    addLocationCondition (filterIndex) {
      let filter = this.subscription.filters[filterIndex]

      let lc = this.subscription.subjectType === 'Property'
        ? { locationConditionType: 'State', stateAbbreviations: [] }
        : this.subscription.subjectType === 'InsuranceClaim'
        ? { locationConditionType: 'Property', propertyIds: [] }
        : { locationConditionType: 'Property', propertyIds: [] }
      filter.locations.push(lc)
      console.log(filter.locations)
    },
    removeLocationCondition (filterIndex, locationIndex) {
      let filter = this.subscription.filters[filterIndex]
      filter.locations.splice(locationIndex, 1)
      // if (filter.locations.length === 0) {
      //   this.subscription.filters.splice(filterIndex, 1)
      // }
    },
    addFilter () {
      let f = {
        conditionsOperator: 'OR',
        conditions: [
          {
            actionType: 'Created',
            qualifier: {
              type: 'Status',
              statusValue: null,
              qualifierSubjectType: this.subscription.subjectType
            }
          }
        ]
      }
      this.subscription.filters.push(f)
    },
    addSubscriber () {
      let subscriber = { recipientType: 'Role', recipientQualifier: null, mediaType: 'Email' }
      this.subscription.subscribers.push(subscriber)
    },
    removeSubscriber (index) {
      this.subscription.subscribers.splice(index, 1)
    },
    onSubjectChange (subject) {
      this.initializeFilterWithCondition()
    },
    onActionTypeChange (condition) {
      let cq = condition.qualifier
      cq.typeId = null
      cq.categoryId = null
      cq.qualifierSubjectType = this.subscription.subjectType
      cq.eventSeverityLevel = 'Low'
      cq.statusValue = null

      if (this.isChangeBasedEvent(condition)) {
        cq.type = 'StatusTypeAndCategory'
        if (condition.actionType === 'TimeElapsed') {
          condition.delayHours = 1
          condition.frequencyType = 'Once'
        } else {
          condition.delayHours = null
          condition.frequencyType = null
        }
      } else {
        condition.delayHours = null
        condition.frequencyType = null
        cq.type = 'TypeAndCategory'
      }
    },
    onRoutineTaskActionTypeChange (condition) {
      condition.qualifier.scheduleType = null
      condition.qualifier.instanceStatus = null
      if (condition.actionType === 'TimeElapsed') {
        condition.frequencyType = 'Once'
        condition.delayHours = 0  // default: notify immediately when overdue
      } else if (condition.actionType === 'DueSoon') {
        condition.frequencyType = 'Once'
        condition.delayHours = 24  // default: 1 day before due
      } else {
        condition.frequencyType = null
        condition.delayHours = null
      }
    },
    onInsurancePolicyActionTypeChange (condition) {
      // Reset updateReasonFilter when switching away from Updated
      if (condition.actionType !== 'Updated') {
        if (condition.qualifier) condition.qualifier.updateReasonFilter = null
      }
      if (condition.actionType === 'DueSoon') {
        condition.frequencyType = condition.frequencyType || 'Once'
        condition.delayHours = condition.delayHours || 720  // default: 30 days before expiry
      } else if (condition.actionType === 'TimeElapsed') {
        condition.frequencyType = condition.frequencyType || 'Once'
        condition.delayHours = 0  // always default to Immediately when switching to TimeElapsed
      } else {
        condition.frequencyType = null
        condition.delayHours = null
      }
    },
    onInsuranceClaimActionTypeChange (condition) {
      // Reset targetStatus when switching away from StatusChanged
      if (condition.actionType !== 'StatusChanged') {
        if (condition.qualifier) condition.qualifier.targetStatus = null
      }
      if (condition.actionType === 'TimeElapsed') {
        condition.delayHours = condition.delayHours || 24  // default: 1 day without status change
        condition.frequencyType = condition.frequencyType || 'Daily'
      } else {
        condition.delayHours = null
        condition.frequencyType = null
      }
    },
    onRecipientTypeChange (subscriber) {
      subscriber.recipientQualifier = null
    },
    onEventTypeChange (condition) {
      condition.qualifier.categoryId = null
    },
    onLocationConditionTypeChange (location, locationIndex, filterIndex) {
      let filter = this.subscription.filters[filterIndex]
      let loc = {locationConditionType: location.locationConditionType}
      switch (loc.locationConditionType) {
        case 'Property':
          loc.propertyIds = []
          break
        case 'PropertyGroup':
          loc.propertyGroupIds = []
          break
        case 'State':
          loc.stateAbbreviations = []
          break
      }
      filter.locations.splice(locationIndex, 1, loc)
    },
    clearSubscription () {
      this.subscription.filtersOperator = 'OR'
      this.subscription.filters = []
    },
    clearConditions () {
      this.subscription.filters = []
    },
    initializeFilterWithCondition () {
      this.subscription.filters = []
      let condition = this.subscription.subjectType === 'Property'
        ? {
            actionType: 'Created',
            frequencyType: null,
            delayHours: null,
            qualifier: { type: 'PropertyQualifier', qualifierSubjectType: 'Property' }
          }
        : this.subscription.subjectType === 'RoutineTask'
        ? {
            actionType: 'Created',
            frequencyType: null,
            delayHours: null,
            qualifier: {
              type: 'RoutineTaskQualifier',
              qualifierSubjectType: 'RoutineTask',
              scheduleType: null,
              instanceStatus: null
            }
          }
        : this.subscription.subjectType === 'InsurancePolicy'
        ? {
            actionType: 'Created',
            frequencyType: null,
            delayHours: null,
            qualifier: {
              type: 'InsurancePolicyQualifier',
              qualifierSubjectType: 'InsurancePolicy',
              policyType: null,
              lineOfCoverageId: null,
              updateReasonFilter: null
            }
          }
        : this.subscription.subjectType === 'InsuranceClaim'
        ? {
            actionType: 'Created',
            frequencyType: null,
            delayHours: null,
            qualifier: {
              type: 'InsuranceClaimQualifier',
              qualifierSubjectType: 'InsuranceClaim',
              claimType: null,
              targetStatus: null
            }
          }
        : {
            actionType: 'TimeElapsed',
            qualifier: {
              type: 'Status',
              statusValue: null,
              qualifierSubjectType: this.subscription.subjectType
            }
          }
      let f = {
        conditionsOperator: 'OR',
        conditions: [condition],
        locations: []
      }
      this.subscription.filters.push(f)
    }
  }
}
</script>
<style scoped>
.card {
  border-radius: .5em;
}
code {
  color: #444;
}
.condition {
  background: rgba(0, 0, 0, 0.05);
}

.overflow-scroll {
  overflow: scroll;
}

.overflow-auto {
  overflow: auto;
}

.condition-separator {
  position: relative;
  z-index: 1;
  height: 60px;
}

.condition-separator:before{
  content: "";
  display: block;
  width: 2px;
  background: #ccc;
  height: 61px;
  margin: auto;
}

.condition-separator-operator {
  font-weight: bold;
  font-size: .9em;
  text-align: center;
  min-width:3em;
  width: 3em;
  height: 3em;
  margin:auto;
  margin-top: -49px;
  padding:unset 5px unset 5px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color:#fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 8px rgba(0,0,0,0.2);
}

.toggle-container {
  margin-top: -30px;
}

.vertical-line {
  border-left: .2em dashed lightgray;
  height: 1.6em;
  margin: auto;
  width:1px;
}

.right {
  margin-left: auto;
}

.alert {
  border-radius: 0 10px 10px 0;
}

.notification-scroller {
  height: calc(100vh - 150px)
}

@media screen and (max-width: 767px) {
  .notification-scroller {
    height: auto;
  }
}
</style>
